/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RetrieveRecourseCriteriaRestResponse } from '../../models/retrieve-recourse-criteria-rest-response';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface FindRecourseCriteriaById$Params {
  id: number;
}

export function findRecourseCriteriaById(
  http: HttpClient,
  rootUrl: string,
  params: FindRecourseCriteriaById$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RetrieveRecourseCriteriaRestResponse>> {
  const rb = new RequestBuilder(rootUrl, findRecourseCriteriaById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RetrieveRecourseCriteriaRestResponse>;
    }),
  );
}

findRecourseCriteriaById.PATH = '/recourse-criteria/{id}';
